<div class="card">
    <div class="card-body">
        <!-- La card se ajusta al contenido (como la vista del solicitante): header +
             tabla de 15 filas + paginador. La tabla hace scroll INTERNO solo si el
             historial expandido supera las 15 filas (max-height en .orders-summary-scroll). -->
        <div class="dataTables_wrapper">
            <div class="row pipes-admin__head">
                <div class="col-sm-12 col-md-12">
                    <!-- Primera línea: título a la izquierda y filtros a la derecha -->
                    <div class="pipes-admin__head-inner">
                        <h2 class="pipes-req__section-title">Solicitudes de Pipas (MOBICO)</h2>

                        <!-- En modo estación (página de estación) el panel queda fijo a la
                             estación seleccionada: solo se ofrece la semana, como en la
                             vista del solicitante. -->
                        <div class="pipes-admin__filters">
                            <div class="select-type" *ngIf="rol === 'Dios' && reqst === 1 && !onlyStation">
                                <app-select-group></app-select-group>
                            </div>
                            <div class="select-city" *ngIf="reqst === 1 && !onlyStation">
                                <app-select-market></app-select-market>
                            </div>
                            <div class="select-type-brand">
                                <!-- "Semana actual" en vez del rango (normalización 2026-07-13,
                                     mismo trato que Solicitudes; el value queda intacto) -->
                                <app-select-week currentWeekLabel="Semana actual"></app-select-week>
                            </div>

                            <!-- Filtro por estación (buscable: se escribe el nombre y filtra) -->
                            <div class="select-station-filter" *ngIf="reqst === 1 && showStations && !onlyStation">
                                <ngx-select class="op-ngx-select" [allowClear]="false" [items]="stationOptions"
                                    optionValueField="value" optionTextField="label" placeholder="Todas las estaciones"
                                    [(ngModel)]="stationFilter" [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="getData()">
                                    <ng-template ngx-select-option-not-found let-input>
                                        "{{input}}" no encontrada
                                    </ng-template>
                                </ngx-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="reqst === 1">

                <!-- Tabla única "Solicitudes" (formato MOBICO): UNA fila por pedido, sin desglose
                     de historial. El Tipo y el estatus reflejan la solicitud en curso: el cambio en
                     vuelo si lo hay (Aprobar/Rechazar responden ese cambio), si no el pedido tal
                     cual. La columna Tipo usa el color de la sección del formato oficial. -->
                <!-- Sin paginación (pedido 2026-07-13): todos los pedidos bajo el
                     scroll interno, pintados por lotes conforme se baja (ver
                     onOrdersScroll — scroll infinito client-side). -->
                <div class="orders-summary-scroll" (scroll)="onOrdersScroll($event)">
                    <!-- trackByProp: SIN él ngx-datatable trackea por índice posicional y al
                         insertar/quitar filas de historial las clases se recorren entre
                         elementos DOM reusados → re-animaba filas que no cambiaron.
                         (rowIdentity NO alimenta el trackBy; es bookkeeping interno.) -->
                    <ngx-datatable class="bootstrap selection-cell orders-summary" [columnMode]="'force'"
                        [headerHeight]="50" [rowHeight]="32" [rows]="requests" [scrollbarV]="false" [scrollbarH]="false"
                        [rowClass]="getRowClass" [rowIdentity]="rowIdentity" [trackByProp]="'_id'"
                        [messages]="{emptyMessage: emptyRequestsMessage}">
                        <!-- minWidth: slot del caret (20px) + chip más largo ("Cambio de capacidad")
                             ≈ 156px; evita que force comprima la columna y corte los chips. -->
                        <ngx-datatable-column prop="type_label" name="Tipo" [width]="160" [minWidth]="165" [sortable]="false"
                            [cellClass]="'left-side green-gray'" [headerClass]="'left-side top-side green-gray'">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <!-- Slot fijo del caret: reserva el mismo ancho en todas las filas
                                     para que el chip quede alineado. El caret solo aparece en el pedido
                                     padre con historial; al expandir, sus filas se insertan debajo. -->
                                <!-- Chevron rotatorio (mecánica de acordeón): un solo ícono que gira
                                     90° al abrir, en lugar de intercambiar right/down sin transición. -->
                                <span class="oh-toggle-slot">
                                    <i class="fa fa-chevron-right oh-toggle" [class.open]="isHistoryOpen(row)"
                                        *ngIf="!row.is_history && row.has_history" title="Ver historial de la solicitud"
                                        aria-hidden="true" (click)="toggleHistory(row)"></i>
                                </span>
                                <span class="type-chip" [ngClass]="row.change_kind">{{ row.type_label }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="po_number" name="PO" [width]="100" [minWidth]="50" [sortable]="false" [headerClass]="'top-side'">
                            <ng-template let-row="row" ngx-datatable-cell-template>{{ row.po_number || '—' }}</ng-template>
                        </ngx-datatable-column>
                        <!-- Fecha de solicitud = cuándo se creó (timestamp real → hora de México).
                             Encabezado en una línea (nowrap del header modernizado); la columna se
                             ensancha para que el texto completo quepa. -->
                        <ngx-datatable-column prop="request_date" name="Fecha de solicitud" [width]="140" [minWidth]="140" [sortable]="false" [headerClass]="'top-side'">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.request_date ? (row.request_date | date:'dd/MM/yy':'-0600':'es') : '—' }}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="order_delivery_date" name="Fecha requerida" [width]="120" [minWidth]="60" [sortable]="false" [headerClass]="'top-side'">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.order_delivery_date ? (row.order_delivery_date | date:'dd/MM/yy':'+0000':'es') : '—' }}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="station_name" name="Estación" [width]="160" [minWidth]="80" [sortable]="false" [headerClass]="'top-side'">
                            <ng-template let-row="row" ngx-datatable-cell-template>{{ row.station_name || '—' }}</ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="truck_capacity" name="Capacidad" [width]="100" [minWidth]="55" [sortable]="false" [headerClass]="'top-side'">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <!-- pTooltip (no el title nativo): aparece al instante, con estilo propio y
                                     se adjunta al body, así la tabla no lo recorta -->
                                <span class="cap-cell" [pTooltip]="capacityTitle(row)" tooltipPosition="top"
                                    [showDelay]="150" tooltipStyleClass="cap-tooltip">
                                    {{ capacityValue(row) != null ? (capacityValue(row) | number:'1.0-0') : '—' }}
                                    <i *ngIf="showCapacityDiff(row)" class="fa fa-info-circle cap-info" aria-hidden="true"></i>
                                </span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="material" name="Producto" [width]="210" [minWidth]="90" [sortable]="false" [headerClass]="'top-side'">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="material-cell" [title]="row.material || ''">{{ row.material || '—' }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <!-- Valor nuevo solicitado (solo cuando hay un cambio en curso; '—' si no) -->
                        <ngx-datatable-column prop="new_value" name="Nuevo valor" [width]="125" [minWidth]="60" [sortable]="false" [headerClass]="'top-side'">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="new-value">{{ row.new_value }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <!-- Respuesta MOBICO = estatus de lo que la fila muestra; el cambio en curso
                             va en color de revisión (naranja) para distinguirlo del pedido normal -->
                        <ngx-datatable-column prop="statusName" name="Respuesta MOBICO" [width]="180" [minWidth]="90" [sortable]="false"
                            [headerClass]="'top-side'">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span class="status-label"
                                    [ngClass]="{'status-confirmed': row.status === 'confirmed', 'status-rejected': row.status === 'rejected', 'status-review': row.status === 'review' || row.in_flight_change}"
                                    [title]="row.week_status || ''">
                                    {{ row.statusName || '—' }}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>
                        <!-- Acciones de la solicitud: botones etiquetados con la pareja de botones
                             del portal (verde CTA / gris), igual que la tabla Solicitudes del
                             solicitante. minWidth evita que columnMode force comprima la columna
                             y corte los botones. -->
                        <ngx-datatable-column name="Acciones" [width]="170" [minWidth]="150" [sortable]="false"
                            [cellClass]="'right-side'" [headerClass]="'top-side right-side'">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <!-- Orden gris → verde (task 2026-07-13 "orden de acciones"):
                                     igual que los modales del flujo — secundaria primero,
                                     la principal (verde) al final. -->
                                <ng-container *ngIf="!row.is_history && isActionable(row); else noActions">
                                    <button type="button" class="row-action-btn gray" title="Rechazar la solicitud"
                                        (click)="rejectOrder(row)">Rechazar</button>
                                    <button type="button" class="row-action-btn green" title="Aprobar la solicitud"
                                        (click)="approveOrder(row)">Aprobar</button>
                                </ng-container>
                                <ng-template #noActions><span class="mobico-response">—</span></ng-template>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>

            </ng-container>

            <div class="row" style="margin:10px;" *ngIf="reqst === 0">
                <app-table-loader style="width: 100%;"></app-table-loader>
            </div>
        </div>
    </div>
</div>

<!-- Modal de confirmación Aprobar/Rechazar: anatomía del custom-alert REAL del portal
     (header neutro, ícono auto-coloreado, título oscuro; el color vive en el ícono y
     en el botón primario). Botones como en todo el portal: gris cerrar, verde confirmar. -->
<!-- op-confirm--compact: sin datos de aceptación (aprobar cancelación / rechazar)
     el modal encoge a 520px; el formato de aprobación con campos no se toca. -->
<div class="modal fade op-modal op-confirm" [class.show]="!!confirmAction"
    [class.op-confirm--compact]="!!confirmAction && !confirmAction.needsDeliveryDate"
    [style.display]="confirmAction ? 'flex' : 'none'"
    tabindex="-1" role="dialog" aria-labelledby="confirmTitle" [attr.aria-hidden]="!confirmAction">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <!-- Ícono en círculo translúcido, como los custom-alert del portal
                     (palomita al aprobar, interrogación al rechazar). -->
                <div class="confirm-icon" aria-hidden="true">
                    <img [src]="'/assets/icons/' + (confirmAction?.status === 'confirmed' ? 'alert-success.svg' : 'alert-confirm.svg')"
                        alt="" width="26" height="26" />
                </div>
                <h5 class="modal-title" id="confirmTitle">{{ confirmAction?.title }}</h5>
                <button type="button" class="close" aria-label="Cerrar" (click)="cancelConfirmAction()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="confirmAction">
                <!-- Sujeto protagonista (chip + PO + estación) y consecuencia en tenue -->
                <div class="confirm-subject">
                    <span class="type-chip" [ngClass]="confirmAction.row.change_kind">{{ confirmAction.row.type_label }}</span>
                    <span>PO {{ confirmAction.row.po_number || '—' }} · {{ confirmAction.row.station_name || '' }}</span>
                </div>
                <p class="confirm-value" *ngIf="confirmAction.row.new_value && confirmAction.row.new_value !== '—'">
                    Nuevo valor: <b>{{ confirmAction.row.new_value }}</b>
                </p>
                <!-- Datos de aceptación (al aprobar un pedido o un cambio; la cancelación
                     no los pide). TODOS opcionales (feedback 2026-07-13): el admin puede
                     aprobar sin capturarlos; solo bloquea una fecha capturada anterior a hoy
                     (confirmActionValid). Mobico puede aceptar una cantidad o fecha
                     distinta a la solicitada. Rejilla de 2 columnas dentro del modal. -->
                <div class="confirm-fields" *ngIf="confirmAction.needsDeliveryDate">
                    <div class="confirm-field">
                        <label for="confirmDeliveryDate">Fecha de entrega</label>
                        <!-- Mini calendario custom (task 2026-07-13 "igual que el selector del
                             cambio de fecha"): input readonly que abre el op-mini-cal flotante
                             con la fecha SOLICITADA marcada en gris y la de entrega en verde.
                             El minDate del picker cubre el "no antes de hoy" (sin tecleo manual). -->
                        <input id="confirmDeliveryDate" type="text" class="form-control cal-input" readonly
                            placeholder="Selecciona la fecha"
                            [value]="confirmDeliveryDate ? (confirmDeliveryDate | date:'dd/MM/yy':'+0000':'es') : ''"
                            (click)="toggleDeliveryCalendar($event)">
                        <small class="confirm-field-error" *ngIf="deliveryDateTooEarly">
                            La fecha de entrega no puede ser anterior a hoy.
                        </small>
                    </div>
                    <div class="confirm-field">
                        <label for="confirmLiters">Litros aceptados</label>
                        <input id="confirmLiters" type="text" inputmode="numeric" class="form-control"
                            appThousands [decimals]="0"
                            [ngModel]="confirmLiters" (ngModelChange)="confirmLiters = $event; onLitersChange()"
                            [ngModelOptions]="{standalone: true}"
                            placeholder="Litros que Mobico acepta">
                    </div>
                    <!-- Costo por litro y costo total van ligados por T = L × P: al
                         escribir uno se calcula el otro con los litros aceptados. -->
                    <div class="confirm-field">
                        <label for="confirmSupplyPrice">Costo por litro</label>
                        <!-- fixedDecimals: el precio siempre con 2 decimales ("21.70", no "21.7") -->
                        <div class="input-affix">
                            <span class="input-affix__prefix" aria-hidden="true">MXN</span>
                            <input id="confirmSupplyPrice" type="text" inputmode="decimal" class="form-control"
                                appThousands [decimals]="2" [fixedDecimals]="true"
                                [ngModel]="confirmSupplyPrice" (ngModelChange)="confirmSupplyPrice = $event; onSupplyPriceChange()"
                                [ngModelOptions]="{standalone: true}"
                                placeholder="Ej. 21.70">
                        </div>
                    </div>
                    <div class="confirm-field">
                        <label for="confirmTotal">Costo total</label>
                        <!-- Pesos mexicanos SIN decimales (formato del equipo 2026-07-13) -->
                        <div class="input-affix">
                            <span class="input-affix__prefix" aria-hidden="true">MXN</span>
                            <input id="confirmTotal" type="text" inputmode="numeric" class="form-control"
                                appThousands [decimals]="0"
                                [ngModel]="confirmTotal" (ngModelChange)="confirmTotal = $event; onTotalChange()"
                                [ngModelOptions]="{standalone: true}"
                                placeholder="Ej. 434,000">
                        </div>
                    </div>
                </div>
                <!-- Calendario de "Fecha de entrega" (réplica del op-mini-cal del cambio de
                     fecha, pipes.component): capa fija transparente que atrapa el click-fuera
                     + panel anclado al campo (calPanelPos, calculado al abrir). Fecha
                     SOLICITADA por la estación en gris (referencia, sí seleccionable: entregar
                     el día pedido es válido) y la fecha de entrega elegida en verde. -->
                <div class="op-cal-overlay" *ngIf="showDeliveryCalendar" (click)="showDeliveryCalendar = false">
                    <div class="op-mini-cal op-mini-cal--modal" [ngStyle]="calPanelPos" (click)="$event.stopPropagation()">
                        <ngb-datepicker
                            [startDate]="calStartDate"
                            [minDate]="calMinDate"
                            navigation="arrows"
                            [dayTemplate]="calDay"
                            [footerTemplate]="calFooter"
                            (dateSelect)="onCalSelect($event)"
                        ></ngb-datepicker>
                        <ng-template #calFooter>
                            <div class="cal-legend">
                                <span class="cal-dot current"></span> Fecha requerida
                                <span class="cal-dot selected"></span> Fecha de entrega
                            </div>
                        </ng-template>
                        <ng-template #calDay let-date let-currentMonth="currentMonth" let-disabled="disabled">
                            <span class="cal-day"
                                [class.cal-outside]="date.month !== currentMonth"
                                [class.cal-disabled]="disabled"
                                [class.cal-current]="isCalRequested(date)"
                                [class.cal-selected]="isCalSelected(date)">{{ date.day }}</span>
                        </ng-template>
                    </div>
                </div>
                <!-- Aprobar un cambio confirma también el pedido completo; el copy lo anuncia -->
                <p class="confirm-note" *ngIf="confirmAction.status === 'confirmed' && confirmAction.row.in_flight_change">
                    Se aprobará el cambio y el pedido completo quedará confirmado;
                    la estación verá la respuesta en su portal.
                </p>
                <p class="confirm-note" *ngIf="!(confirmAction.status === 'confirmed' && confirmAction.row.in_flight_change)">
                    Se {{ confirmAction.status === 'confirmed' ? 'aprobará' : 'rechazará' }} esta solicitud
                    y la estación verá la respuesta en su portal.
                </p>
                <p class="confirm-error" *ngIf="confirmError">{{ confirmError }}</p>
            </div>
            <div class="modal-footer">
                <button class="confirm-btn gray" (click)="cancelConfirmAction()" [disabled]="respondingOrder">Cancelar</button>
                <button class="confirm-btn green" (click)="confirmRespond()" [disabled]="respondingOrder || !confirmActionValid">
                    {{ respondingOrder ? 'Guardando…' : confirmAction?.actionLabel }}
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade show" *ngIf="confirmAction" (click)="cancelConfirmAction()"></div>

